import { Grid } from '@mui/material';
import { DealReducedFeeLender } from '../../shared/models';
import {
	CerebroHeading,
	CerebroIcon,
	CerebroLabel,
	CerebroPrimaryButton,
	CerebroStyledBox,
	CerebroText,
	CerebroTextButton,
} from '../../shared/components';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface ReducedFeeLenderDisplayProps {
	lenders: DealReducedFeeLender[];
	invalid: boolean | undefined;
	onDelete: (lender: DealReducedFeeLender) => void;
	onAdd: (show: boolean) => void;
	reducedLenderCount: number;
}

export const ReducedFeeLenderDisplay: React.FC<ReducedFeeLenderDisplayProps> = ({
	lenders,
	invalid,
	onDelete,
	onAdd,
	reducedLenderCount,
}) => {
	return lenders && lenders.length > 0 ? (
		<>
			<Grid container spacing={2} sx={{ marginY: 3 }}>
				<Grid item xs={10}>
					<CerebroLabel>Lender</CerebroLabel>
				</Grid>
				<Grid item xs={2}></Grid>
				{lenders.map(lender => (
					<React.Fragment key={lender.guid}>
						<Grid item xs={10}>
							<CerebroText variant="small">{lender.bankName}</CerebroText>
						</Grid>
						<Grid item xs={2}>
							<CerebroTextButton
								color="error"
								title={`Remove ${lender.bankName}`}
								onClick={() => onDelete(lender)}
							>
								Remove
								<CerebroIcon padLeft>
									<FontAwesomeIcon icon={faTrash} size="sm" />
								</CerebroIcon>
							</CerebroTextButton>
						</Grid>
					</React.Fragment>
				))}

				<Grid item xs={12}>
					<CerebroTextButton size="small" variant="outlined" onClick={() => onAdd(true)}>
						Include Another Lender
					</CerebroTextButton>
				</Grid>
				<Grid item xs={12}>
					<CerebroText variant="hint">
						Reduced Fee Lender Limit: <strong>{reducedLenderCount}</strong>
					</CerebroText>
				</Grid>
			</Grid>

			<hr />
		</>
	) : (
		<>
			<CerebroStyledBox sx={{ marginY: 6 }} error={invalid}>
				<CerebroHeading size="h2" component="h2" sx={{ marginBottom: 4 }}>
					You have not included any reduced fee lenders on this loan yet.
				</CerebroHeading>
				<Grid container justifyContent="center">
					<Grid item>
						<CerebroPrimaryButton wide onClick={onAdd}>
							Include Reduced Fee Lender
						</CerebroPrimaryButton>
					</Grid>
				</Grid>
				<Grid item xs={12}>
					<CerebroText variant="hint">
						Reduced Fee Lender Limit: <strong>{reducedLenderCount}</strong>
					</CerebroText>
				</Grid>
				{invalid && (
					<CerebroText variant="error" sx={{ marginTop: 4 }}>
						You indicated that you have reduced fee lenders to include but did not specify any lender for
						this loan. Please include at least one lender for this loan.
					</CerebroText>
				)}
			</CerebroStyledBox>
		</>
	);
};
